import { useNavigate } from "@tanstack/react-router";
import { useTranslations } from "use-intl";

import { Switcher } from "@/components/Switcher/Switcher";
import { SwitcherButton } from "@/components/Switcher/SwitcherButton";
import {
  rudderAnalytics,
  FlightSearchTrackingEvents,
  HotelSearchTrackingEvents,
} from "@/lib/rudderstack";

type SearchCategorySwitcherProps = {
  current: "flights" | "hotels";
};

const eventMap = {
  flights: FlightSearchTrackingEvents.USER_SWITCHED_TO_FLIGHT_SEARCH,
  hotels: HotelSearchTrackingEvents.USER_SWITCHED_TO_HOTEL_SEARCH,
} as const;

export const SearchCategorySwitcher = ({
  current,
}: SearchCategorySwitcherProps) => {
  const t = useTranslations();
  const navigate = useNavigate();

  return (
    <Switcher
      value={current}
      onChange={(newCategory) => {
        if (eventMap[newCategory]) {
          rudderAnalytics.track(eventMap[newCategory]);
        }

        if (newCategory === "flights") {
          navigate({
            to: "/flights/search",
            replace: true,
          });

          return;
        }

        navigate({
          to: "/hotels/search",
          replace: true,
        });
      }}
    >
      <SwitcherButton value="flights" label={t("flights.title")} />
      <SwitcherButton value="hotels" label={t("hotels.title")} />
    </Switcher>
  );
};
